import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './household-size.reducer';

export const HouseholdSizeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const householdSizeEntity = useAppSelector(state => state.householdSize.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="householdSizeDetailsHeading">
          <Translate contentKey="apiLocationApp.householdSize.detail.title">HouseholdSize</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{householdSizeEntity.id}</dd>
          <dt>
            <span id="geographicLevel">
              <Translate contentKey="apiLocationApp.householdSize.geographicLevel">Geographic Level</Translate>
            </span>
          </dt>
          <dd>{householdSizeEntity.geographicLevel}</dd>
          <dt>
            <span id="date">
              <Translate contentKey="apiLocationApp.householdSize.date">Date</Translate>
            </span>
          </dt>
          <dd>{householdSizeEntity.date}</dd>
          <dt>
            <span id="geography">
              <Translate contentKey="apiLocationApp.householdSize.geography">Geography</Translate>
            </span>
          </dt>
          <dd>{householdSizeEntity.geography}</dd>
          <dt>
            <span id="geographyCode">
              <Translate contentKey="apiLocationApp.householdSize.geographyCode">Geography Code</Translate>
            </span>
          </dt>
          <dd>{householdSizeEntity.geographyCode}</dd>
          <dt>
            <span id="totalAllHouseholds">
              <Translate contentKey="apiLocationApp.householdSize.totalAllHouseholds">Total All Households</Translate>
            </span>
          </dt>
          <dd>{householdSizeEntity.totalAllHouseholds}</dd>
          <dt>
            <span id="onePerson">
              <Translate contentKey="apiLocationApp.householdSize.onePerson">One Person</Translate>
            </span>
          </dt>
          <dd>{householdSizeEntity.onePerson}</dd>
          <dt>
            <span id="twoPeople">
              <Translate contentKey="apiLocationApp.householdSize.twoPeople">Two People</Translate>
            </span>
          </dt>
          <dd>{householdSizeEntity.twoPeople}</dd>
          <dt>
            <span id="threePeople">
              <Translate contentKey="apiLocationApp.householdSize.threePeople">Three People</Translate>
            </span>
          </dt>
          <dd>{householdSizeEntity.threePeople}</dd>
          <dt>
            <span id="fourPeople">
              <Translate contentKey="apiLocationApp.householdSize.fourPeople">Four People</Translate>
            </span>
          </dt>
          <dd>{householdSizeEntity.fourPeople}</dd>
          <dt>
            <span id="fivePeople">
              <Translate contentKey="apiLocationApp.householdSize.fivePeople">Five People</Translate>
            </span>
          </dt>
          <dd>{householdSizeEntity.fivePeople}</dd>
          <dt>
            <span id="sixPeople">
              <Translate contentKey="apiLocationApp.householdSize.sixPeople">Six People</Translate>
            </span>
          </dt>
          <dd>{householdSizeEntity.sixPeople}</dd>
          <dt>
            <span id="sevenPeople">
              <Translate contentKey="apiLocationApp.householdSize.sevenPeople">Seven People</Translate>
            </span>
          </dt>
          <dd>{householdSizeEntity.sevenPeople}</dd>
          <dt>
            <span id="eightOrMorePeople">
              <Translate contentKey="apiLocationApp.householdSize.eightOrMorePeople">Eight Or More People</Translate>
            </span>
          </dt>
          <dd>{householdSizeEntity.eightOrMorePeople}</dd>
        </dl>
        <Button tag={Link} to="/household-size" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/household-size/${householdSizeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default HouseholdSizeDetail;
